import renderCheckbox from 'components/FormControls/checkboxField'
import renderSelect from 'components/FormControls/select'
import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { change, Field, untouch } from 'redux-form'
import BicField from 'modules/Forms/Finance/PaymentProfileCreate/subcomponents/BicField'
import { useDispatch } from 'react-redux'

const TAX_SYSTEM_INDIVIDUAL = [
  'simple',
  'basic',
  'automated_simple',
  'patent',
  'professional_income',
]

const TAX_SYSTEM_JURIDICAL = ['simple', 'basic', 'automated_simple']

const JuridicalRu = ({ details, form }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const taxSystemList = useMemo(
    () =>
      details.legal_personality === 'individual' ? TAX_SYSTEM_INDIVIDUAL : TAX_SYSTEM_JURIDICAL,
    [details.legal_personality],
  )

  const methodHandleChange = useCallback(() => {
    dispatch(change(form, 'details.tax_system', '', false, false))
    dispatch(untouch(form, 'details.tax_system'))
  }, [])

  return (
    <>
      <div className={'margin-bottom-16'}>
        <Field
          label={t('payment_profiles::new.fields.details.legal_personality.label')}
          name="details.legal_personality"
          component={renderSelect}
          fullWidth
          t={t}
          showEmptyOption={false}
          normalize={(value = '') => value}
          emptyOptionLabel={t('common::select_empty_option')}
          clearOptionLabel={t('common::select_clear_option')}
          onChange={methodHandleChange}
          options={['juridical', 'juridical_ano', 'individual'].map((val) => ({
            value: val,
            label: t(`payment_profiles::new.fields.details.legal_personality.options.${val}`),
          }))}
        />
      </div>

      {!!details.legal_personality && (
        <>
          <div className={'margin-bottom-16'}>
            <Field
              label={t('payment_profiles::new.fields.details.tax_system.label')}
              name="details.tax_system"
              component={renderSelect}
              fullWidth
              t={t}
              normalize={(value = '') => value}
              emptyOptionLabel={t('common::select_empty_option')}
              clearOptionLabel={t('common::select_clear_option')}
              options={taxSystemList.map((key) => ({
                value: key,
                label: t(`payment_profiles::new.fields.details.tax_system.options.${key}`),
              }))}
            />
          </div>

          {details.legal_personality !== 'individual' && (
            <div className={'margin-bottom-16'}>
              <Field
                fullWidth
                name="details.kpp"
                component={renderInputField}
                label={t('payment_profiles::new.fields.details.kpp.label')}
                normalize={(value = '') => value.replace(/\D/g, '').substr(0, 9)}
                t={t}
              />
            </div>
          )}
          {details.legal_personality !== 'individual' && (
            <div className={'margin-bottom-16'}>
              <Field
                fullWidth
                name="details.ogrn"
                component={renderInputField}
                label={t('payment_profiles::new.fields.details.ogrn.label')}
                normalize={(value = '') => value.replace(/\D/g, '').substr(0, 13)}
                t={t}
              />
            </div>
          )}
          {details.legal_personality !== 'individual' && (
            <div className={'margin-bottom-16'}>
              <Field
                fullWidth
                name="details.general_director"
                component={renderInputField}
                label={t('payment_profiles::new.fields.details.general_director.label')}
                t={t}
              />
            </div>
          )}
          <div className={'margin-bottom-16'}>
            <Field
              fullWidth
              name="details.juridical_address"
              component={renderInputField}
              label={t('payment_profiles::new.fields.details.juridical_address.label')}
              t={t}
            />

            <Field
              className={'margin-top-8'}
              name="details.is_same_address"
              checked={details?.is_same_address}
              component={renderCheckbox}
              label={t('payment_profiles::new.fields.details.is_same_address.label')}
              t={t}
            />
          </div>
          {details?.is_same_address === false && (
            <div className={'margin-bottom-16'}>
              <Field
                fullWidth
                name="details.actual_address"
                component={renderInputField}
                label={t('payment_profiles::new.fields.details.actual_address.label')}
                t={t}
              />
            </div>
          )}
          {details.legal_personality === 'individual' && (
            <div className={'margin-bottom-16'}>
              <Field
                fullWidth
                name="details.ogrnip"
                component={renderInputField}
                label={t('payment_profiles::new.fields.details.ogrnip.label')}
                normalize={(value = '') => value.replace(/\D/g, '').substr(0, 15)}
                t={t}
              />
            </div>
          )}
          <div className={'margin-bottom-16'}>
            <BicField form={form} />
          </div>
          <div className={'margin-bottom-16'}>
            <Field
              fullWidth
              name="details.bank_name"
              component={renderInputField}
              label={t('payment_profiles::new.fields.details.bank_name.label')}
              t={t}
              normalize={(value) => value.replace(/[«|»]/g, '"')}
            />
          </div>
          <div className={'margin-bottom-16'}>
            <Field
              fullWidth
              name="details.correspondent_account"
              component={renderInputField}
              label={t('payment_profiles::new.fields.details.correspondent_account.label')}
              normalize={(value = '') => value.replace(/\D/g, '').substr(0, 20)}
              t={t}
            />
          </div>
          <div className={'margin-bottom-16'}>
            <Field
              fullWidth
              name="details.checking_account"
              component={renderInputField}
              label={t('payment_profiles::new.fields.details.checking_account.label')}
              normalize={(value = '') => value.replace(/\D/g, '').substr(0, 20)}
              t={t}
            />
          </div>
        </>
      )}
    </>
  )
}

JuridicalRu.propTypes = {
  details: PropTypes.object,
  form: PropTypes.string,
}

export default JuridicalRu
